import { Routes, Route } from 'react-router-dom';
import Home from './Home';
import Products from './Products';
import Admin from './Admin';
import NotFound from './NotFound';
import './App.css';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/products" element={<Products />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
